export const isRelayQuoteUtxoItemData = (item) => {
    return 'psbt' in item;
};
export const isRelayQuoteEvmItemData = (item) => {
    return 'to' in item && 'data' in item && 'value' in item;
};
export const isRelayQuoteSolanaItemData = (item) => {
    return 'instructions' in item;
};
export var RelayErrorCode;
(function (RelayErrorCode) {
    RelayErrorCode["AmountTooLow"] = "AMOUNT_TOO_LOW";
    RelayErrorCode["Erc20RouterAddressNotFound"] = "ERC20_ROUTER_ADDRESS_NOT_FOUND";
    RelayErrorCode["ExtraTransactionsNotSupported"] = "EXTRA_TXS_NOT_SUPPORTED";
    RelayErrorCode["InsufficientFunds"] = "INSUFFICIENT_FUNDS";
    RelayErrorCode["InsufficientLiquidity"] = "INSUFFICIENT_LIQUIDITY";
    RelayErrorCode["InvalidAddress"] = "INVALID_ADDRESS";
    RelayErrorCode["InvalidExtraTransactions"] = "INVALID_EXTRA_TXS";
    RelayErrorCode["NoQuotes"] = "NO_QUOTES";
    RelayErrorCode["NoSwapRoutesFound"] = "NO_SWAP_ROUTES_FOUND";
    RelayErrorCode["PermitFailed"] = "PERMIT_FAILED";
    RelayErrorCode["SwapImpactTooHigh"] = "SWAP_IMPACT_TOO_HIGH";
    RelayErrorCode["SwapQuoteFailed"] = "SWAP_QUOTE_FAILED";
    RelayErrorCode["Unauthorized"] = "UNAUTHORIZED";
    RelayErrorCode["UnknownError"] = "UNKNOWN_ERROR";
    RelayErrorCode["UnsupportedChain"] = "UNSUPPORTED_CHAIN";
    RelayErrorCode["UnsupportedCurrency"] = "UNSUPPORTED_CURRENCY";
    RelayErrorCode["UnsupportedExecutionType"] = "UNSUPPORTED_EXECUTION_TYPE";
    RelayErrorCode["UnsupportedRoute"] = "UNSUPPORTED_ROUTE";
    RelayErrorCode["UserRecipientMismatch"] = "USER_RECIPIENT_MISMATCH";
})(RelayErrorCode || (RelayErrorCode = {}));
export const isRelayError = (error) => {
    return typeof error === 'object' && error !== null && 'errorCode' in error && 'message' in error;
};
